import React, { useEffect, createElement } from "react";
import { XIcon } from "lucide-react";
interface CalendlyModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export const CalendlyModal = ({
  isOpen,
  onClose
}: CalendlyModalProps) => {
  useEffect(() => {
    // Load Calendly script when modal is opened
    if (isOpen) {
      const script = document.createElement("script");
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      script.async = true;
      document.body.appendChild(script);
      
      // Add custom styles
      const style = document.createElement("style");
      style.textContent = `
        .calendly-inline-widget iframe {
          display: block;
        }
        .calendly-event-type-details {
          display: none !important;
        }
      `;
      document.head.appendChild(style);
      
      // Add Calendly event listener for scheduling
      window.addEventListener('calendly.event_scheduled', function(e) {
        // Track the scheduling event with Meta Pixel
        if (window.fbq) {
          window.fbq('track', 'Schedule');
        }
      });
      
      return () => {
        // Cleanup script and styles when modal is closed
        document.body.removeChild(script);
        document.head.removeChild(style);
        window.removeEventListener('calendly.event_scheduled', function(e) {
          if (window.fbq) {
            window.fbq('track', 'Schedule');
          }
        });
      };
    }
  }, [isOpen]);
  
  if (!isOpen) return null;
  
  return <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={onClose}></div>
      <div className="relative min-h-screen flex items-center justify-center p-4">
        <div className="relative bg-white rounded-lg w-full max-w-4xl">
          <button onClick={onClose} className="absolute right-4 top-4 text-gray-500 hover:text-indigo-600 z-10" aria-label="Close modal">
            <XIcon size={24} />
          </button>
          <div className="calendly-inline-widget w-full" data-url="https://calendly.com/wcs-jackcarlsoncopy/free-audit?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=4f46e5" style={{
          minWidth: "320px",
          height: "700px"
        }}></div>
        </div>
      </div>
    </div>;
};